export const pbDemoData = [
  {
    stickyTracking: false,
    name: "Shampoo",
    data: [
      { name: "Head & Shoulders", value: 28.0, valueShare: "£1,957,683" },
      { name: "Alberto Balsam", value: 24.0, valueShare: "£1,138,675" },
      { name: "Pantene", value: 9.0, valueShare: "£427,229" },
      { name: "TRESemme", value: 9.0, valueShare: "£408,900" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
    ],
  },
  {
    stickyTracking: false,
    name: "Conditioner",
    data: [
      { name: "Alberto Balsam", value: 40.0, valueShare: "£790,534" },
      { name: "TRESemme", value: 14.0, valueShare: "£281,265" },
      { name: "Pantene", value: 13.0, valueShare: "£252,177" },
      { name: "Elvive", value: 6.0, valueShare: "£113,980" },
      { name: "Herbal Essences", value: 6.0, valueShare: "£108,832" },
    ],
  },
  {
    stickyTracking: false,
    name: "Styling",
    data: [
      { name: "Silvikrin", value: 26.0, valueShare: "£922,882" },
      { name: "Bristows", value: 15.0, valueShare: "£530,801" },
      { name: "Insette", value: 12.0, valueShare: "£420,875" },
      { name: "VOS", value: 11.0, valueShare: "£379,863" },
      { name: "Alberto Balsam", value: 9.0, valueShare: "£304,920" },
    ],
  },
];

export const pbDemoMoreContentData = [
  {
    stickyTracking: false,
    name: "Shampoo",
    data: [
      { name: "Head & Shoulders", value: 28.0, valueShare: "£1,957,683" },
      { name: "Alberto Balsam", value: 24.0, valueShare: "£1,138,675" },
      { name: "Pantene", value: 9.0, valueShare: "£427,229" },
      { name: "TRESemme", value: 9.0, valueShare: "£408,900" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
      { name: "Head & Shoulders", value: 28.0, valueShare: "£1,957,683" },
      { name: "Alberto Balsam", value: 24.0, valueShare: "£1,138,675" },
      { name: "Pantene", value: 9.0, valueShare: "£427,229" },
      { name: "TRESemme", value: 9.0, valueShare: "£408,900" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
    ],
  },
  {
    stickyTracking: false,
    name: "Conditioner",
    data: [
      { name: "Alberto Balsam", value: 40.0, valueShare: "£790,534" },
      { name: "TRESemme", value: 14.0, valueShare: "£281,265" },
      { name: "Pantene", value: 13.0, valueShare: "£252,177" },
      { name: "Elvive", value: 6.0, valueShare: "£113,980" },
      { name: "Herbal Essences", value: 6.0, valueShare: "£108,832" },
      { name: "Alberto Balsam", value: 40.0, valueShare: "£790,534" },
      { name: "TRESemme", value: 14.0, valueShare: "£281,265" },
      { name: "Pantene", value: 13.0, valueShare: "£252,177" },
      { name: "Elvive", value: 6.0, valueShare: "£113,980" },
      { name: "Herbal Essences", value: 6.0, valueShare: "£108,832" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
    ],
  },
  {
    stickyTracking: false,
    name: "Styling",
    data: [
      { name: "Silvikrin", value: 26.0, valueShare: "£922,882" },
      { name: "Bristows", value: 15.0, valueShare: "£530,801" },
      { name: "Insette", value: 12.0, valueShare: "£420,875" },
      { name: "VOS", value: 11.0, valueShare: "£379,863" },
      { name: "Alberto Balsam", value: 9.0, valueShare: "£304,920" },
      { name: "Silvikrin", value: 26.0, valueShare: "£922,882" },
      { name: "Bristows", value: 15.0, valueShare: "£530,801" },
      { name: "Insette", value: 12.0, valueShare: "£420,875" },
      { name: "VOS", value: 11.0, valueShare: "£379,863" },
      { name: "Alberto Balsam", value: 9.0, valueShare: "£304,920" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
    ],
  },
];

export const pbDemo64ContentData = [
  {
    stickyTracking: false,
    name: "Shampoo",
    data: [
      { name: "Head & Shoulders", value: 28.0, valueShare: "£1,957,683" },
      { name: "Alberto Balsam", value: 24.0, valueShare: "£1,138,675" },
      { name: "Pantene", value: 9.0, valueShare: "£427,229" },
      { name: "TRESemme", value: 9.0, valueShare: "£408,900" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
      { name: "Head & Shoulders", value: 28.0, valueShare: "£1,957,683" },
      { name: "Alberto Balsam", value: 24.0, valueShare: "£1,138,675" },
      { name: "Pantene", value: 9.0, valueShare: "£427,229" },
      { name: "TRESemme", value: 9.0, valueShare: "£408,900" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
      { name: "Head & Shoulders", value: 28.0, valueShare: "£1,957,683" },
      { name: "Alberto Balsam", value: 24.0, valueShare: "£1,138,675" },
      { name: "Pantene", value: 9.0, valueShare: "£427,229" },
      { name: "TRESemme", value: 9.0, valueShare: "£408,900" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
      { name: "Head & Shoulders", value: 28.0, valueShare: "£1,957,683" },
      { name: "Alberto Balsam", value: 24.0, valueShare: "£1,138,675" },
      { name: "Pantene", value: 9.0, valueShare: "£427,229" },
      { name: "TRESemme", value: 9.0, valueShare: "£408,900" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
    ],
  },
  {
    stickyTracking: false,
    name: "Conditioner",
    data: [
      { name: "Alberto Balsam", value: 40.0, valueShare: "£790,534" },
      { name: "TRESemme", value: 14.0, valueShare: "£281,265" },
      { name: "Pantene", value: 13.0, valueShare: "£252,177" },
      { name: "Elvive", value: 6.0, valueShare: "£113,980" },
      { name: "Herbal Essences", value: 6.0, valueShare: "£108,832" },
      { name: "Alberto Balsam", value: 40.0, valueShare: "£790,534" },
      { name: "TRESemme", value: 14.0, valueShare: "£281,265" },
      { name: "Pantene", value: 13.0, valueShare: "£252,177" },
      { name: "Elvive", value: 6.0, valueShare: "£113,980" },
      { name: "Herbal Essences", value: 6.0, valueShare: "£108,832" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
      { name: "Alberto Balsam", value: 40.0, valueShare: "£790,534" },
      { name: "TRESemme", value: 14.0, valueShare: "£281,265" },
      { name: "Pantene", value: 13.0, valueShare: "£252,177" },
      { name: "Elvive", value: 6.0, valueShare: "£113,980" },
      { name: "Herbal Essences", value: 6.0, valueShare: "£108,832" },
      { name: "Alberto Balsam", value: 40.0, valueShare: "£790,534" },
      { name: "TRESemme", value: 14.0, valueShare: "£281,265" },
      { name: "Pantene", value: 13.0, valueShare: "£252,177" },
      { name: "Elvive", value: 6.0, valueShare: "£113,980" },
      { name: "Herbal Essences", value: 6.0, valueShare: "£108,832" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
    ],
  },
  {
    stickyTracking: false,
    name: "Styling",
    data: [
      { name: "Silvikrin", value: 26.0, valueShare: "£922,882" },
      { name: "Bristows", value: 15.0, valueShare: "£530,801" },
      { name: "Insette", value: 12.0, valueShare: "£420,875" },
      { name: "VOS", value: 11.0, valueShare: "£379,863" },
      { name: "Alberto Balsam", value: 9.0, valueShare: "£304,920" },
      { name: "Silvikrin", value: 26.0, valueShare: "£922,882" },
      { name: "Bristows", value: 15.0, valueShare: "£530,801" },
      { name: "Insette", value: 12.0, valueShare: "£420,875" },
      { name: "VOS", value: 11.0, valueShare: "£379,863" },
      { name: "Alberto Balsam", value: 9.0, valueShare: "£304,920" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
      { name: "Silvikrin", value: 26.0, valueShare: "£922,882" },
      { name: "Bristows", value: 15.0, valueShare: "£530,801" },
      { name: "Insette", value: 12.0, valueShare: "£420,875" },
      { name: "VOS", value: 11.0, valueShare: "£379,863" },
      { name: "Alberto Balsam", value: 9.0, valueShare: "£304,920" },
      { name: "Silvikrin", value: 26.0, valueShare: "£922,882" },
      { name: "Bristows", value: 15.0, valueShare: "£530,801" },
      { name: "Insette", value: 12.0, valueShare: "£420,875" },
      { name: "VOS", value: 11.0, valueShare: "£379,863" },
      { name: "Alberto Balsam", value: 9.0, valueShare: "£304,920" },
      { name: "Batiste", value: 5.0, valueShare: "£213,248" },
    ],
  },
];

export const pbHealthBeautyData = [
  {
    stickyTracking: false,
    name: "£40-£80m",
    data: [
      { name: "Radox", value: 75.6 },
      { name: "Ella's Kitchen", value: 74.2 },
      { name: "Venus", value: 73.9 },
      { name: "Aveeno", value: 72.5 },
      { name: "Huggies", value: 71.0 },
      { name: "Cera Ve", value: 69.8 },
      { name: "Listerine", value: 69.5 },
      { name: "Aussie", value: 59.5 },
      { name: "Olay", value: 58.2 },
      { name: "Durex", value: 57.4 },
      { name: "John Frieda", value: 57.2 },
      { name: "Tresemme", value: 56.8 },
      { name: "Nicorette", value: 55.3 },
      { name: "Pantene", value: 54.7 },
      { name: "Sanex", value: 54.1 },
      { name: "Tampax", value: 52.6 },
      { name: "Always Discreet", value: 50.1 },
      { name: "Carex", value: 48.2 },
      { name: "Strepsils", value: 48.1 },
      { name: "SMA", value: 45.7 },
      { name: "Rennie", value: 43.9 },
      { name: "Sudafed", value: 42.8 },
      { name: "Vaseline", value: 41.9 },
    ],
    dataLabels: {
      style: {
        color: "white",
      },
    },
  },
  {
    stickyTracking: false,
    name: "£80-£100m",
    data: [
      { name: "Simple", value: 98.1 },
      { name: "Cow & Gate", value: 97.5 },
      { name: "Elvive", value: 97.4 },
      { name: "Gaviscon", value: 91.6 },
      { name: "Lemsip", value: 82.9 },
      { name: "Nurofen", value: 82.1 },
      { name: "Calpol", value: 80.9 },
      { name: "Head & Shoulders", value: 80.7 },
    ],
    dataLabels: {
      style: {
        color: "#092F50",
      },
    },
  },
  {
    stickyTracking: false,
    name: "£100m+",
    data: [
      { name: "Colgate", value: 275.7 },
      { name: "Pampers", value: 250.4 },
      { name: "Oral-B", value: 239.9 },
      { name: "Dove", value: 204.1 },
      { name: "Nivea", value: 175.9 },
      { name: "Gillette", value: 172.5 },
      { name: "Sure", value: 165.0 },
      { name: "Aptamil", value: 145.3 },
      { name: "Tena", value: 133.7 },
      { name: "L’Oreal", value: 132.9 },
      { name: "Always", value: 120.4 },
      { name: "Garnier", value: 119.4 },
      { name: "Lynx", value: 112.8 },
      { name: "Sensodyne", value: 109.2 },
    ],
    dataLabels: {
      style: {
        color: "#092F50",
      },
    },
  },
];

export const pbHouseholdData = [
  {
    stickyTracking: false,
    name: "£40-£80m",
    data: [
      { name: "Flash", value: 76.8 },
      { name: "Purina One", value: 74.9 },
      { name: "Vanish", value: 72.4 },
      { name: "Air Wick", value: 72.3 },
      { name: "Domestos", value: 70.5 },
      { name: "Winalot", value: 70.0 },
      { name: "Glade", value: 67.1 },
      { name: "Go Cat", value: 52.2 },
      { name: "Webbox", value: 51.5 },
      { name: "Dreamies", value: 46.7 },
      { name: "Ecover", value: 46.2 },
      { name: "Yankee Candle", value: 45.8 },
      { name: "Mr Muscle", value: 44.9 },
      { name: "Wagg", value: 41.6 },
    ],
    dataLabels: {
      style: {
        color: "white",
      },
    },
  },
  {
    stickyTracking: false,
    name: "£80-£100m",
    data: [
      { name: "Good Boy", value: 90.7 },
      { name: "Bold", value: 90.3 },
      { name: "Harringtons", value: 85.2 },
    ],
    dataLabels: {
      style: {
        color: "#092F50",
      },
    },
  },
  {
    stickyTracking: false,
    name: "£100m+",
    data: [
      { name: "Andrex", value: 444.4 },
      { name: "Felix", value: 316.6 },
      { name: "Fairy (Dish)", value: 246.1 },
      { name: "Whiskas", value: 229.9 },
      { name: "Fairy (Fabric)", value: 214.0 },
      { name: "Pedigree", value: 191.4 },
      { name: "Persil", value: 189.0 },
      { name: "Lenor", value: 182.9 },
      { name: "Cushelle", value: 178.7 },
      { name: "Ariel", value: 163.3 },
      { name: "Gourmet", value: 142.0 },
      { name: "Comfort", value: 138.8 },
      { name: "Kleenex", value: 132.5 },
      { name: "Finish", value: 119.7 },
      { name: "Surf", value: 115.6 },
      { name: "Dettol", value: 109.1 },
      { name: "Febreze", value: 107.5 },
      { name: "Bakers", value: 102.2 },
      { name: "Sheba", value: 101.1 },
      { name: "Butchers", value: 100.7 },
    ],
    dataLabels: {
      style: {
        color: "#092F50",
      },
    },
    pointFormatter: function () {
      // Ensure that decimal values with ".0" are always displayed
      return (
        "<b>" +
        this.name +
        ":</b> £" +
        (this.value % 1 === 0 ? this.value.toFixed(1) : this.value) +
        "m"
      );
    },
  },
];

export const tabDataOverview = [
  "Market Overview",
  "Personal Care",
  "Baby Care",
  "Healthcare & Medicines",
  "Household & Laundry",
  "Pet Food",
];

export const tabDataPb = ["Health, Beauty & Baby", "Household & Pet"];
